import { Injectable, Inject, Injector } from '@angular/core';
// import { ToastrService } from 'ngx-toastr';
// import { Notyf } from 'notyf';
import { NotyfService } from 'ng-notyf';

@Injectable({providedIn: 'root'})
export class NotificationService {

    // private notyf: Notyf = null;

    constructor (
        // @Inject(Injector) private readonly injector: Injector
        // private notify: ToastrService
        private notyfService: NotyfService
    ) {
        // this.notify = this.injector.get(ToastrService);
        // this.notyf = new Notyf();
    }

    // private get notify(): ToastrService {
    //     // return this.injector.get(ToastrService);
    //     return this._notify;
    // }

    showError(message: string, title = '') {
        // this.notyf.error(message);
        // this.notify.error(message, title);
        this.notyfService.error(message);
    }

    showSuccess(message: string, title = '') {
        // this.notyf.success(message);
        // this.notify.success(message, title);
        this.notyfService.success(message);
    }
    
}
